// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Work {
  /* section background to make 'What we offer?' stand out */
  background: #c6d2e9ff; /* light grey */
  color: #111;
  padding: 56px 20px;
  border-radius: 12px; /* rounded inner card to match section */
}
.Work-inner {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 24px;
}
.Work-heading {
  font-size: 2rem;
  margin: 0 0 12px 0;
}
.Work-lead {
  margin: 0 0 28px 0;
  color: #333;
}
.Work-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}
.Work-card {
  background: #e1e1f1ff;
  padding: 18px;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.04);
}

.Work-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  color: #2563eb; /* blue accent for icons */
}
.Work-icon svg {
  width: 48px;
  height: 48px;
  display: block;
}

@media (max-width: 900px) {
  .Work-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/Work.css"],"names":[],"mappings":"AAAA;EACE,0DAA0D;EAC1D,qBAAqB,EAAE,eAAe;EACtC,WAAW;EACX,kBAAkB;EAClB,mBAAmB,EAAE,wCAAwC;AAC/D;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc,EAAE,0BAA0B;AAC5C;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".Work {\n  /* section background to make 'What we offer?' stand out */\n  background: #c6d2e9ff; /* light grey */\n  color: #111;\n  padding: 56px 20px;\n  border-radius: 12px; /* rounded inner card to match section */\n}\n.Work-inner {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n.Work-heading {\n  font-size: 2rem;\n  margin: 0 0 12px 0;\n}\n.Work-lead {\n  margin: 0 0 28px 0;\n  color: #333;\n}\n.Work-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n}\n.Work-card {\n  background: #e1e1f1ff;\n  padding: 18px;\n  border-radius: 8px;\n  box-shadow: 0 1px 2px rgba(0,0,0,0.04);\n}\n\n.Work-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 12px;\n  color: #2563eb; /* blue accent for icons */\n}\n.Work-icon svg {\n  width: 48px;\n  height: 48px;\n  display: block;\n}\n\n@media (max-width: 900px) {\n  .Work-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
